import GlobalRewardsDropdown from "components/molecules/GlobalRewardsDropdown";
import {
  CountryDetails,
  GlobalRewardsModalMobile,
} from "components/molecules/GlobalRewardsModal/GlobalRewardsModalMobile";
import { Reward, RewardCountry } from "components/pages/GlobalRewards/types";
import dynamic from "next/dynamic";
import React, { FC } from "react";
import styled from "styled-components";

const GlobalMap = dynamic(() => import("components/pages/GlobalRewards/global-map"), {
  ssr: false,
  loading: () => <p>Loading map...</p>,
});

interface RewardsMapMobile {
  handleCountryClick: (countryId: string) => void;
  handleContinentClick: (continent: string) => void;
  selectedCountry: string | null;
  rewardCountries: RewardCountry[];
  countryRewards: Reward[];
  countryDetails: CountryDetails;
  resetCountryModalOnChange: () => void;
}

export const RewardsMapMobile: FC<RewardsMapMobile> = ({
  handleCountryClick,
  handleContinentClick,
  rewardCountries,
  selectedCountry,
  countryDetails,
  countryRewards,
  resetCountryModalOnChange,
}) => {
  return (
    <Container>
      <DropdownContainer>
        <GlobalRewardsDropdown
          countries={rewardCountries}
          onCountryClick={handleCountryClick}
          onContinentClick={handleContinentClick}
          resetCountryModalOnChange={resetCountryModalOnChange}
          selectedCountry={selectedCountry}
        />
      </DropdownContainer>
      {selectedCountry ? (
        <GlobalRewardsModalMobile
          rewards={countryRewards}
          countryDetails={countryDetails}
          resetCountryModalOnChange={resetCountryModalOnChange}
        />
      ) : (
        <GlobalMap />
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem 0;
`;

const DropdownContainer = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;
